import { Component, OnInit, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { ValidationsService } from '../../services/validations.service';
import { CatalogosService } from '../../services/catalogos.service';
import { environment } from '../../../environments/environment';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-plan-apertura',
  templateUrl: './plan-apertura.page.html',
  styleUrls: ['./plan-apertura.page.scss']
})
@Injectable({
  providedIn: 'root'
})
export class PlanAperturaPage implements OnInit {
  faInfoCircle = faInfoCircle;
  title = 'angulartitle';

  loading: any = false;
  hasSession: any = false;
  llaveData: any = {};
  tramites: any = [];
  localRoute: any = {
    _value: null
  };
  resultados: any;

  constructor(
    public route: Router,
    private router: ActivatedRoute,
    private sessionService: SessionService,
    private validateService: ValidationsService,
    private catalogosService: CatalogosService,
    private titleService: Title
  ) {
    this.localRoute = this.router.queryParams;
    // this.titleService.setTitle(title);
  }

  async ngOnInit() {
    // Validate if session is active and exists
    this.loading = true;
    await this.catalogosService.getPlanApertura()
      .then((res) => { this.resultados = res; });
    this.loading = false;
  }
}
